import styleCustomProps from '@ctn/ui/components/ctn-utils/styleCustomProps';
import classNames from 'classnames';
import React, { useMemo } from 'react';

type ImageBoxProps = {
	readonly className?: string;
	readonly children?: React.ReactElement | React.ReactElement[];
	readonly img?: string;
	readonly filter?: { opacity: number; color: string };
};

const classNameComponent = 'c-pnp-image-box';

const ImageBox = ({ className, children, filter, img }: ImageBoxProps) => {
	const classNameImageBox = useMemo(() => classNames(className, classNameComponent), [className]);

	const stylesImageBox = useMemo(
		() =>
			styleCustomProps({
				'--c-pnp-image-box--BackgroundColor': { value: filter?.color },
			}),
		[filter],
	);

	return (
		<div className={classNameImageBox} style={stylesImageBox}>
			<div className={`${classNameComponent}__content`}>{children}</div>
			<figure className={`${classNameComponent}__figure`}>
				<img className={`${classNameComponent}__bg`} src={img} alt="" />
			</figure>
		</div>
	);
};

export default ImageBox;
